import { create } from 'zustand';

import { HotelModelFirestoreResponse } from '../types';

interface HotelState {
    hotelData: HotelModelFirestoreResponse;
    loading: boolean;
    setHotelData: (data: HotelModelFirestoreResponse) => void;
    setLoading: (loading: boolean) => void;
}

export const useHotelState = create<HotelState>((set) => ({
  hotelData: {
    name: '',
    brand_url: '',
    id: '',
    cover_photo: '',
    address: {
      postal_code: '',
      geoPoint: {
        latitude: 0,
        longitude: 0,
      },
      street: '',
      city_name: '',
      number: '',
    },
    mobileAppAvailable: false,
    chatAvailable: false,
    stars: 0,
  },
  loading: true,
  setHotelData: (data: HotelModelFirestoreResponse) => set({ hotelData: data }),
  setLoading: (loading: boolean) => set({ loading }),
}));
